export default "__VITE_ASSET__qzEOVHPT__"